// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'


import 'fullpage.js/vendors/scrolloverflow' // Optional. When using fullpage extensions
import fullpage from 'fullpage.js/dist/fullpage.extensions.min'
import VueFullPage from 'vue-fullpage.js'

import VueCountUp from 'vue-countupjs'


import MetaInfo from 'vue-meta-info'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

import axios from 'axios'

Vue.prototype.$axios = axios    //把axios挂载到vue的原型中，在vue中每个组件都可以使用axios发送请求
Vue.prototype.HOME = '/api'

import wow from 'wowjs'
Vue.prototype.$wow = wow


Vue.use(MetaInfo);
Vue.use(VueCountUp);
Vue.use(VueAwesomeSwiper);
if(document.documentElement.clientWidth > 1023){
  Vue.use(VueFullPage);
}
console.log(document.documentElement.clientWidth)


Vue.config.productionTip = false

router.afterEach((to,from,next) => {
   window.scrollTo(0,0);
});

/* eslint-disable no-new */

if(document.body.clientWidth > 1024){

}

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  created() {

  },
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
})



// WEBPACK FOOTER //
// ./src/main.js